import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-average-star-rating',
  templateUrl: './average-star-rating.component.html',
  styleUrls: ['./average-star-rating.component.scss']
})
export class AverageStarRatingComponent implements OnInit {
  @Input() maxCount: number;
  @Input() averageRating: number;
  @Input() ratingType: string;
  @Input() chartData: any;
  ratingArray;
  starContainerMaxWidth = 100;
  filledInStarsContainerWidth;

  constructor() { }

  ngOnInit() {
    this.activate();
  }

  activate() {
    if (!this.maxCount) {
      this.maxCount = 5;
    }
    if (this.chartData && this.chartData.hasOwnProperty('tdata') && this.chartData.tdata.hasOwnProperty('sdata')) {
      const sDataLen = Object.keys(this.chartData.tdata.sdata).length;
      this.maxCount = sDataLen ? sDataLen : this.chartData.tdata.star_count;
    }

    this.ratingArray = [];
    for (let i = 1; i <= this.maxCount; i++) {
      let obj = {};
      obj['disabled'] = i > this.chartData.tdata.star_count ? true : false; // special case. In case star rating is changed later mark particular rating as disabled
      obj['empty'] = !this.chartData.tdata.sdata[`star${i}_per`] ? true : false; // if rating count is 0, mark it as empty
      this.ratingArray.push(obj);
    }

    const disabledItemArr = this.ratingArray.filter(star => star.disabled === true);
    this.filledInStarsContainerWidth = 100;
    if (!disabledItemArr.length) {
      this.filledInStarsContainerWidth = this.averageRating / this.maxCount * this.starContainerMaxWidth;
    }
  }

}
